import { LiaAngleLeftSolid } from "react-icons/lia";
import { Link } from "react-router-dom";
import PhoneInput from "./PhoneInput";
import ImageUploadPreview from "../ImageUploadPreview";
import * as Yup from "yup";
import { useFormik } from "formik";
import FormBox from "../FormBox";
import CountryDropdown from "./CountryDropdown";

export default function Profile({ className, onClick }) {
    const formik = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            phone: "",
            email: "",
            country: {
                id: 0,
                name: ""
            },
            state: {
                id: 0,
                name: ""
            },
            address1: "",
            address2: "",
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required("First name is required"),
            lastName: Yup.string().required("Last name is required"),
            country: Yup.object()
                .shape({
                    id: Yup.number().min(1, "Country is required").required("Country is required"),
                })
                .required("Country is required"),
            /*phone: Yup.string()
                .required("Phone number is required")
                .matches(/^[7-9]{1}[0-9]{9}$/, "Phone number must be 10 digits and start with 7, 8, or 9"),*/
            email: Yup.string().email("Invalid email address").required("Email is required"),
            country: Yup.string().required("Country is required"),
            state: Yup.string().required("State is required"),
            address1: Yup.string().required("Address Line 1 is required"),
            address2: Yup.string().required("Address Line 2 is required"),
        }),
        onSubmit: (values) => {
            // console.log("Form Data", values);
        },
    });

    return (
        <div
            className={`login-otp align-items-center justify-content-end p-3 p-md-4 position-fixed top-0 start-0 w-100 z-2 bg-black bg-opacity-20 h-100 ${className}`}
        >
            <div className="login-otp-wrap bg-white py-4 px-3 rounded-4 h-100">
                <div className="login-otp-scroll h-100 px-2 d-flex flex-column overflow-auto">
                    <div className="login-popup-header position-sticky top-0 start-0 z-2 w-100 bg-white d-flex align-items-center gap-2 mb-3 pb-md-1">
                        <button className="login-close text-body d-flex align-items-center justify-content-center rounded-pill border-0 p-0" onClick={onClick}>
                            <LiaAngleLeftSolid />
                        </button>
                        <h4 className="mb-0">Complete my Profile</h4>
                    </div>

                    <div className="d-grid grid-count-2 align-items-center flex-wrap gap-3 mb-3">
                        <FormBox
                            type="text"
                            label="First Name"
                            name="firstName"
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            placeholder="First Name"
                            error={formik.touched.firstName && formik.errors.firstName}
                        />
                        <FormBox
                            type="text"
                            label="Last Name"
                            name="lastName"
                            value={formik.values.lastName}
                            onChange={formik.handleChange}
                            placeholder="Last Name"
                            error={formik.touched.lastName && formik.errors.lastName}
                        />
                    </div>

                    {/*<PhoneInput
                        label="Phone"
                        name="phone"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        error={formik.touched.phone && formik.errors.phone}
                    /> */}
                    <FormBox
                        className="mb-3"
                        type="email"
                        label="Email"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        placeholder="Enter your email address"
                    />
                    {formik.touched.email && formik.errors.email && (
                        <div className="text-danger fs-12">{formik.errors.email}</div>
                    )}

                    <div className="mb-3">
                        <CountryDropdown
                            name="country"
                            formik={formik}
                        />

                    </div>

                    <FormBox
                        className="mb-3"
                        type="text"
                        label="Address Line 1"
                        name="address1"
                        value={formik.values.address1}
                        onChange={formik.handleChange}
                        placeholder="Enter your address"
                    />
                    {formik.touched.address1 && formik.errors.address1 && (
                        <div className="text-danger fs-12">{formik.errors.address1}</div>
                    )}

                    <FormBox
                        className="mb-3"
                        type="text"
                        label="Address Line 2"
                        name="address2"
                        value={formik.values.address2}
                        onChange={formik.handleChange}
                        placeholder="Enter your address"
                    />
                    {formik.touched.address2 && formik.errors.address2 && (
                        <div className="text-danger fs-12">{formik.errors.address2}</div>
                    )}

                    {/* <ImageUploadPreview className="mb-4" id="profile_upload" /> */}

                    <div className="d-flex flex-column gap-2 mt-auto">
                        <button onClick={onClick} className="btn bg-transparent w-100 fs-14 mb-1">
                            Skip
                        </button>
                        <button onClick={formik.handleSubmit} type="submit" className="btn bg-primary w-100 fs-14">
                            Save Information
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
